import { SET_PAYMENT_LIST } from "../../types";

const setPaymentList = (paymentList) => (dispatch) => {
  dispatch({ type: SET_PAYMENT_LIST, paymentList });
};

export { setPaymentList };
